<template>
	<b-modal
		ref="chick-searcher-modal"
		size="xmd"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">Buscador de pollos</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>

		<b-overlay :show="isLoading">
			<b-row class="d-flex align-items-center justify-content-start mx-1 mb-2">
				<div class="d-flex flex-column align-items-end gap-y-2">
					<div class="d-flex justify-content-start align-items-center">
						<div>Pata IZQ:</div>
						<v-select
							label="description"
							class="mx-1"
							:options="colorOptions"
							:reduce="(opt) => opt.description"
							style="width: 220px"
							v-model="selectedColor1"
							placeholder="Seleccionar color #1"
						>
							<template #option="option">
								<div class="flex items-center">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
							<template #selected-option="option">
								<div class="flex items-center">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
						</v-select>
						<v-select
							label="description"
							class="mx-1"
							:options="colorOptions"
							style="width: 220px"
							:reduce="(opt) => opt.description"
							v-model="selectedColor2"
							placeholder="Seleccionar color #2"
						>
							<template #option="option">
								<div class="flex items-center">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
							<template #selected-option="option">
								<div class="d-flex align-items-center justify-content-between">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
						</v-select>
					</div>
					<div class="d-flex justify-content-start align-items-center">
						<div>Pata DER:</div>
						<v-select
							label="description"
							class="mx-1"
							:options="colorOptions"
							:reduce="(opt) => opt.description"
							style="width: 220px"
							v-model="selectedColor3"
							placeholder="Seleccionar color #1"
						>
							<template #option="option">
								<div class="flex items-center">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
							<template #selected-option="option">
								<div class="flex items-center">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
						</v-select>
						<v-select
							label="description"
							class="mx-1"
							:options="colorOptions"
							style="width: 220px"
							:reduce="(opt) => opt.description"
							v-model="selectedColor4"
							placeholder="Seleccionar color #2"
						>
							<template #option="option">
								<div class="flex items-center">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
							<template #selected-option="option">
								<div class="d-flex align-items-center justify-content-between">
									<span class="fa-squaress mr-1">
										<feather-icon
											:style="`color: ${option.color}; background: ${option.color}; border-radius: 3px;`"
											icon="SquareIcon"
											size="25"
										/>
									</span>
									<span>{{ option.description }}</span>
								</div>
							</template>
						</v-select>
					</div>
				</div>
				<div class="d-flex gap-x-2">
					<b-button variant="outline-primary" @click="getRows">
						<FeatherIcon icon="SearchIcon" />
					</b-button>
					<b-button variant="info" @click="cleanFilters">
						<BroomSweepingSvg class="text-white" />
					</b-button>
				</div>
			</b-row>
			<b-table-simple responsive sticky-header="60vh" no-border-collapse style="min-height: 60vh">
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">
							{{ field.label }}
							<v-icon
								v-if="field.key === 'local' || field.key === 'rival'"
								name="gi-boxing-glove"
								scale="1.3"
								class="ml-1"
								:class="field.key === 'local' ? 'text-danger' : 'text-primary'"
								style="transform: rotate(270deg)"
							/>
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="chicks.length > 0">
						<b-tr v-for="(chick, index) in chicks" :key="index">
							<b-td class="text-center">
								<div v-if="chick.cintillo" class="d-flex">
									<div v-if="[1, 3].includes(chick.cintillo.chickenleg_wich_leg)">
										<div>PATA IZQ</div>
										<CombChickenlegsCintillos
											:postura="{
												id: chick.cintillo.id,
												chickenleg_wich_leg: chick.cintillo.chickenleg_wich_leg,
												chickenleg_qty_cintillos: chick.cintillo.qty_cintillos,
												cintillo_color: chick.cintillo.hex_1,
												cintillo_description: chick.cintillo.description_1,
												second_color_color: chick.cintillo.hex_2,
												second_color_description: chick.cintillo.description_2,
												total_minus_infertile_eggs: 1,
											}"
											:chickenleg_wich_leg="1"
										/>
									</div>
									<div v-if="[2, 3].includes(chick.cintillo.chickenleg_wich_leg)">
										<div>PATA DER</div>
										<CombChickenlegsCintillos
											:postura="{
												id: chick.cintillo.id,
												chickenleg_wich_leg: chick.cintillo.chickenleg_wich_leg,
												chickenleg_qty_cintillos: chick.cintillo.qty_cintillos,
												cintillo_color: chick.cintillo.hex_1,
												cintillo_description: chick.cintillo.description_1,
												second_color_color: chick.cintillo.hex_2,
												second_color_description: chick.cintillo.description_2,
												total_minus_infertile_eggs: 1,
											}"
											:chickenleg_wich_leg="2"
										/>
									</div>
								</div>
							</b-td>
							<b-td class="text-center">
								<b-badge variant="primary">
									{{ chick.correlative }}
								</b-badge>
							</b-td>
							<b-td class="text-center">
								{{ chick.alias }}
							</b-td>
							<b-td class="text-center">
								<SpecimenPlate
									v-if="chick.padrillo"
									:specimen="chick.padrillo"
									show_status
									show_details_icon
								/>
							</b-td>
							<b-td class="text-center">
								<SpecimenPlate
									v-if="chick.madrilla"
									:specimen="chick.madrilla"
									show_status
									show_details_icon
								/>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="chicks.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
	</b-modal>
</template>

<script>
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
import ChickCintillosService from "@/views/amg/general/chick-cintillos/services/chick-cintillos.service.js"
import CombChickenlegsCintillos from "@/views/amg/encaste/lotes/components/CombChickenlegsCintillos.vue"
import lotesService from "@/services/lotes.service.js"
import BroomSweepingSvg from "@/icons/BroomSweepingSvg.vue"
export default {
	name: "ChickSearcherModal",
	props: {
		selectedGroup: {
			type: Object,
			default: null,
		},
	},
	components: {
		SpecimenPlate,
		CombChickenlegsCintillos,
		BroomSweepingSvg,
	},
	data: () => ({
		search: "",
		isLoading: false,
		fields: [
			{ key: "cintilloPata", label: "CINTILLO PATA", class: "text-center" },
			{ key: "cintilloAla", label: "CINTILLO ALA", class: "text-center" },
			{ key: "corral", label: "CORRAL", class: "text-center" },
			{ key: "padrillo", label: "PADRILLO", class: "text-center" },
			{ key: "madrilla", label: "MADRILLA", class: "text-center" },
		],
		colorOptions: [],
		selectedColor1: null,
		selectedColor2: null,
		selectedColor3: null,
		selectedColor4: null,
		chicks: [],
	}),
	methods: {
		cleanFilters() {
			this.selectedColor1 = null
			this.selectedColor2 = null
			this.selectedColor3 = null
			this.selectedColor4 = null
			this.chicks = []
		},
		async getActiveColors() {
			const { data } = await lotesService.getChickCintilloColors()
			this.colorOptions = data
		},
		refresh() {
			this.getRows()
		},
		handleInputSearch() {
			this.getRows()
		},
		handleCloseModal() {
			this.$emit("refresh")
			this.$emit("close")
		},
		async getRows(page = 1) {
			try {
				this.isLoading = true
				if (!this.selectedColor1 && !this.selectedColor2 && !this.selectedColor3 && !this.selectedColor4) {
					this.chicks = []
					return
				}
				const { data } = await ChickCintillosService.list({
					color1: this.selectedColor1,
					color2: this.selectedColor2,
					color3: this.selectedColor3,
					color4: this.selectedColor4,
				})
				this.chicks = data || []
			} catch (error) {
				console.error("Error fetching chicks by cintillos:", error)
			} finally {
				this.isLoading = false
			}
		},
	},

	mounted() {
		this.getActiveColors()
		this.getRows()
		this.$refs["chick-searcher-modal"].toggle()
	},
}
</script>
